const hasMinLength = (value) => value.length >= 8;
const hasUpperCase = (value) => /[A-Z]/.test(value);
const hasLowerCase = (value) => /[a-z]/.test(value);
const hasDigit = (value) => /\d/.test(value);
const hasSpecialChar = (value) => /[@$!%*?&]/.test(value);

const validatePassword = (password) => {
  const errors = [];
  if (!hasMinLength(password)) {
    errors.push("يجب أن يكون طول كلمة السر 8 أحرف على الأقل.");
  }
  if (!hasUpperCase(password)) {
    errors.push("كلمة السر يجب أن تحتوي على حرف كابيتل واحد على الأقل.");
  }
  if (!hasLowerCase(password)) {
    errors.push("كلمة السر يجب أن تحتوي على حرف سمول واحد على الأقل.");
  }
  if (!hasDigit(password)) {
    errors.push("يجب أن تحتوي كلمة السر على رقم واحد على الأقل.");
  }
  if (!hasSpecialChar(password)) {
    errors.push("كلمة السر يجب أن تحتوي على حرف خاص واحد على الأقل (@$!%*?&).");
  }
  return errors;
};
export default validatePassword;
